import { ListOfDays } from '../..'
import getSundayBeforeTheMonth from './getSundayBeforeTheMonth'

function getDaysForTheCalendar(month: number, year: number, maxDaysToGet = 42) {
  const listOfDays: ListOfDays[] = []

  let dayCount = 0

  const firstSundayOfTheMonth = getSundayBeforeTheMonth(month, year)

  while (dayCount < maxDaysToGet) {
    const stringDate = firstSundayOfTheMonth.toLocaleString().substring(0, 10)

    listOfDays[dayCount] = {
      stringDate,
      day: firstSundayOfTheMonth.getDate(),
    }

    if (month === firstSundayOfTheMonth.getMonth()) {
      listOfDays[dayCount].isThisMounth = true
    }

    dayCount = dayCount + 1

    firstSundayOfTheMonth.setDate(firstSundayOfTheMonth.getDate() + 1)
  }

  return listOfDays
}

export default getDaysForTheCalendar
